import type { Permissions } from '@/hooks/usePermissions';

type CanOnly = Pick<Permissions, 'can'>;

/**
 * Settings (/settings) opens for its own permission, and for the motif managers
 * of a league: the disciplinary advocate manages motifs without any other
 * Settings right.
 */
export function canOpenSettings(p: CanOnly): boolean {
  return p.can('view', 'settings') || p.can('manage', 'disciplinary_reason');
}

/** Only the Discipline tab (Motifs + Cumuls) — nothing else in Settings. */
export function isMotifsOnlySettings(p: CanOnly): boolean {
  return !p.can('view', 'settings') && p.can('manage', 'disciplinary_reason');
}
